/**
 * カスタムセレクト
 */
export const SELECT = {
  selectors: {
    root: '.js-select',
    head: '.js-select-head',
  },

  classNames: {
    open: 'is-open',
  },

  init() {
    const roots = document.querySelectorAll(this.selectors.root)

    if (!roots.length) {
      return
    }

    roots.forEach(root => {
      const head = root.querySelector(this.selectors.head)

      if (!head) {
        return
      }

      head.addEventListener('click', event => {
        event.stopPropagation()
        this.toggle(root)
      })
    })

    document.addEventListener('click', () => {
      this.closeAll()
    })
  },

  toggle(root) {
    const isOpen = root.classList.contains(this.classNames.open)

    this.closeAll()

    if (!isOpen) {
      root.classList.add(this.classNames.open)
    }
  },

  closeAll() {
    document.querySelectorAll(this.selectors.root).forEach(root => {
      root.classList.remove(this.classNames.open)
    })
  },
}
